import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import {
  BottomBar,
  Copyright,
  PhotoDisclaimer,
  SocialSection,
  LinksSection,
  Links,
  Container,
  LegalTextSection,
} from './termsBar.styles';
import { FooterSocialIcons } from '../content/content.styles';
import { renderWhenTrue } from '../../../utils/rendering';

export class TermsBar extends PureComponent {
  static propTypes = {
    links: PropTypes.object,
    socialLinks: PropTypes.object,
    copyright: PropTypes.string,
    photoDisclaimer: PropTypes.string,
  };

  renderSocialLinks = renderWhenTrue(() => (
    <SocialSection>
      <FooterSocialIcons icons={this.props.socialLinks} row />
    </SocialSection>
  ));

  renderLinks = renderWhenTrue(() => (
    <LinksSection>
      <Links links={this.props.links} row />
    </LinksSection>
  ));

  renderCopyright = renderWhenTrue(() => (
    <Copyright as="section">{this.props.copyright}</Copyright>
  ));

  renderPhotoDisclaimer = renderWhenTrue(() => (
    <PhotoDisclaimer as="section">{this.props.photoDisclaimer}</PhotoDisclaimer>
  ));

  render() {
    const { copyright, links, socialLinks, photoDisclaimer } = this.props;

    return (
      <BottomBar>
        <Container>
          {this.renderSocialLinks(!!socialLinks)}
          {this.renderLinks(!!links)}
          <LegalTextSection>
            {this.renderCopyright(!!copyright)}
            {this.renderPhotoDisclaimer(!!photoDisclaimer)}
          </LegalTextSection>
        </Container>
      </BottomBar>
    );
  }
}
